import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import SectionHeader from "../common/sectionHeader";
import INFO from "../../data/user";
import "./styles/experienceTimeline.css";

const ExperienceTimeline = () => {
	return (
		<section className="experience-section">
			<SectionHeader
				tag="Career History"
				title="Professional Software"
				highlight="Engineering Experience"
				subtitle="1+ year of enterprise experience building scalable backend services, optimizing PostgreSQL database performance, and implementing secure APIs."
			/>

			<div className="experience-timeline">
				{INFO.experience.map((exp, index) => (
					<motion.div
						key={index}
						className={`experience-card ${index === 0 ? "featured" : ""}`}
						initial={{ opacity: 0, y: 24 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.4, delay: index * 0.15 }}
					>
						<div className="exp-header">
							<div className="exp-company-info">
								<img src={exp.logo} alt={exp.company} className="exp-logo" />
								<div>
									<div className="exp-company-name">{exp.company}</div>
									<div className="exp-role">{exp.role} • {exp.location}</div>
								</div>
							</div>
							<span className="exp-period">{exp.period}</span>
						</div>

						<p className="exp-description">{exp.description}</p>

						<div className="exp-highlights">
							{exp.highlights.map((item, idx) => (
								<div key={idx} className="exp-highlight-item">
									<CheckCircle2 size={16} className="exp-highlight-icon" />
									<span>{item}</span>
								</div>
							))}
						</div>

						<div className="exp-tags">
							{exp.tags.map((tag, idx) => (
								<span key={idx} className="tech-pill">
									{tag}
								</span>
							))}
						</div>
					</motion.div>
				))}
			</div>
		</section>
	);
};

export default ExperienceTimeline;
